<template>
  <div class="container-fluid input-field">

    <input type="hidden" :name="name" v-model="newValue"/>

    <div class="row">
      <div class="col s6">
        <img class="responsive-img circle not-so-big" :src="actual_image" alt="Immagine attualmente selezionata"/>
      </div>
      <div class="col s6">

        <button class="btn success align-center" @click="openModal('upload_modal_'+id)" type="button">Carica nuova
        </button>
      </div>
      <div class="col s2 m2">

      </div>
    </div>

    <div class="modal modal-fixed-footer" :id="'upload_modal_'+id">
      <div class="modal-content">
        <div class="card lighten-4" @dragover="dragover" @dragleave="dragleave" @drop="drop">
          <div class="card-content">
            <h3><label :for="id">Trascina un immagine dentro questo box, oppure <u>clicca qui</u>. </label></h3>
            <div class="row">
              <div class="col s12">
                <div class="input-field">
                  <input :id="id" type="file" ref="file" @input="change"/>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button class="btn danger" type="button" @click="closeModal('upload_modal_'+id)">Annulla</button>
      </div>
    </div>

    <div class="modal bottom-sheet" :id="'crop_modal_'+id">
      <div class="modal-content">
        <cropper
            class="cropper"
            :src="image"
            :stencil-props="stencilProps"
            :min-width="256"
            @change="changeSize"
            :min-height="256"
            stencilComponent="circle-stencil"
            :canvas="true"
        />
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="button" @click="sendCrop(path)">Ritaglia</button>
        <button class="btn danger" type="button" @click="closeModal('crop_modal_'+id)">Annulla</button>
      </div>
    </div>
  </div>

</template>

<script>

import Vue from 'vue';

export default {
  name: "ObjectStorageImageuploader",

  props: {

    s3_path: {
      required: true,
      type: String
    },
    s3_bucket: {
      required: true,
      type: String
    },
    entity_id: {
      required: true,
      type: Number
    },
    entity_type: {
      required: true,
      type: String
    },
    actual_image: {
      required: true,
      type: String
    },
    id: {
      required: true,
      type: String
    },
    name: {
      required: true,
      type: String,
    }
  },

  data() {
    return {
      files: null,

      newValue: '',
      // forcedValue: '',

      image: '',
      path: '',
      stencilProps: {
        aspectRatio: 1,
      },

      crop: null,
    }
  },

  methods: {

    // // TODO remove this test method
    // forceField: function () {
    //   this.newValue = this.forcedValue;
    // },

    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('green')) {
        event.currentTarget.classList.add('green');
      }
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('green');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      // Clean up
      event.currentTarget.classList.remove('green');

      this.handleFileUrl(); // Trigger the onChange event manually
    },

    change: function () {
      // console.log('FILE CHANGED', this.$refs.file.files);
      this.files = this.$refs.file.files;
      this.handleFileUrl();
    },

    changeSize: function (params) {
      // console.log(params.coordinates);
      Vue.set(this, 'crop', params.coordinates);
    },

    handleFileUrl: function () {
      this.sendFile(null)
          .then(response => {
            // console.log('Non ci credo', response);
            if (response.hasOwnProperty('data')) {
              this.image = '/storage/' + response.data.bucket + '/' + response.data.path;
              this.path = response.data.path;
              this.openModal('crop_modal_' + this.id);
              this.closeModal('upload_modal_' + this.id)
            }
          })
          .catch(console.log);
    },
    /*
    handleOldImage: function () {
      this.image = this.actual_image;
      this.openModal('crop_modal_' + this.id);
    },
     */

    sendFile: function (path) {
      // console.log('SEND FILE', this.files);
      let formData = new FormData;

      if (path) {
        formData.append('path', path);
      }

      formData.append('entity_id', this.entity_id);
      formData.append('entity_type', this.entity_type);

      formData.append('immagine[]', this.files[0]);


      return window.axios.post('/index.php?option=com_api&app=asdgest&resource=file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },

    sendCrop: function (path) {
      // console.log('SEND CROP', this.crop);
      let data = {};

      data.entity_id = this.entity_id;
      data.entity_type = this.entity_type;

      if (this.crop !== null) {
        data.x = this.crop.left;
        data.y = this.crop.top;
        data.width = this.crop.width;
        data.height = this.crop.height;
        data.path = this.path
      }

      this.newValue = path;

      window.axios.put('/index.php?option=com_api&app=asdgest&resource=file', data)
          .then(response => {
            // console.log(response);
            this.closeModal('crop_modal_' + this.id);
            this.newValue = this.path;
            window.M.toast({html: '<span>Nuova immagine caricata correttamente, ora devi salvare le modifiche per renderle effettive.</span>', displayLength: 120000});
          })
          .catch( error => {
            console.error(error);

            window.M.toast({html: '<span>C\'è stato un problema nel caricamento. Riprovare, e contattare la segreteria in caso di ripetuto errore.</span>', displayLength: 120000});
          });
    },

    openModal: function (id) {
      let elem = document.getElementById(id);
      if (!elem) {
        console.log('Error: no modal element!', id);
        return;
      }
      const modal = M.Modal.init(elem);
      modal.open();
    },

    closeModal: function (id) {
      let elem = document.getElementById(id);
      if (!elem) {
        console.log('Error: no modal element!', id);
        return;
      }
      const modal = M.Modal.getInstance(elem);
      modal.close();
    }
  },

  // mounted() {
  //   console.log('Hello there, this is data', this.data, this.path);
  // }
}
</script>

<style scoped lang="scss">

</style>
